const Utils = require('core-helpers/utils.js');

const QueryParameters = ((root, doc, undefined) => {

    /**
     * Returns the institution parameters if present in the URL.
     * @return {Object}
     */
    const getInstitutionParameters = () => {
        const code = Utils.getParameter('institution_code');
        const name = Utils.getParameter('institution_name');
        if (!code || !name) {
            return {};
        }
        return {
            institution_code: code,
            institution_name: name
        };
    };

    return {
        getInstitutionParameters
    };

})(window, document);

module.exports = QueryParameters;
